// import logo from './logo.svg';
/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { observer } from 'mobx-react';

import useApp from '../store/models/app/useApp';
import { v4 as uuid } from 'uuid';

import Calendars from '../pages/calendars'; 
import Loading from '../pages/loading';
import Schedules from '../pages/schedules';
import Success from '../pages/success';
import SubscriberForm from '../pages/subscriber';
import OauthLauncher from '../pages/oauthLauncher';
import OauthTalking from '../pages/transitions/oauthTalking';
import OauthLoading from '../pages/transitions/oauthLoading';
import OauthFailed from '../pages/transitions/oauthFailed'
import InAppRedirect from '../pages/inappredirect';
import InAppGuide from '../pages/inappGuide';
import ICSLink from '../pages/icslink';
import ICSLinkOutlook from '../pages/icslinkOutlook';
import OutlookNewGuide from '../pages/icslinkOutlook/guide';
import Errors from '../pages/errors';

import AlmostDone from '../pages/almostdone'
import HavingTrouble from '../pages/havingtrouble';

import {
    useCommonStoreStates,
    CommonStoresContext,
} from '../store/useCommonStores';

import {
    UIStatesContext,
    useUIStatesManager,
} from '../store/models/uistates/useUIStates';

import useAnimations from '../store/models/animations/useAnimations';

function WrappedRoutes ({ store }) {
    const { appStore } = useApp();
    const commonStores = useCommonStoreStates({});
    const uiStates = useUIStatesManager({ store });

    const {
        renderAnimatedViews,
    } = useAnimations({});

    return (
        <UIStatesContext.Provider value={uiStates}>
        <CommonStoresContext.Provider value={commonStores}>
            <React.Fragment>

                <Routes>
                    <Route
                        path="/loading"
                        element={<Loading />}
                    />

                    <Route
                        path="/inappredirect"
                        element={<InAppRedirect />}
                    />

                    <Route
                        path="/inAppGuide"
                        element={<InAppGuide />}
                    />

                    <Route
                        path="/oauthlauncher"
                        element={<OauthLauncher />}
                    />

                    <Route
                        path="/oauthTalking"
                        element={<OauthTalking />}
                    />

                    <Route
                        path="/oauthloading"
                        element={<OauthLoading />}
                    />

                    <Route
                        path="/oauthfail"
                        element={<OauthFailed />}
                    />

                    <Route
                        path="/calendars"
                        element={<Calendars />}
                    />

                    <Route
                        path="/schedules"
                        element={<Schedules />}
                    />

                    <Route
                        path="/success"
                        element={<Success />}
                    />

                    <Route
                        path="/subscriber"
                        element={<SubscriberForm />}
                    />

                    <Route
                        path="/icslink"
                        element={<ICSLink />}
                    />

                    <Route
                        path="/almostdone"
                        element={<AlmostDone />}
                    />

                    <Route
                        path="/outlook-new"
                        element={<ICSLinkOutlook />}
                    />

                    <Route
                        path="/outlook-new-guide"
                        element={<OutlookNewGuide />}
                    />

                    <Route
                        path="/havingtrouble"
                        element={<HavingTrouble />}
                    />

                    <Route
                        path="/errors"
                        element={<Errors />}
                    />

                    <Route
                        path="/"
                        element={<Loading />}
                    />

                    <Route
                        path="*"
                        element={<Loading />}
                    />
                </Routes>
                { renderAnimatedViews() }

                   <a
                        href="/oauthTalking"
                        id='oauth-launcher-button'
                        target="ECAL:OAUTH_SYNCWINDOW"
                        style={{
                            display: 'none',
                            position: 'absolute',
                        }}
                        onClick={() => {
                            function pollWindow () {
                                const blob = uuid();
                                let oauthWindow = null;
                                if (appStore.flags.safari) {
                                    oauthWindow = window.open('', `ECAL:OAUTH_SYNCWINDOW`);
                                } else {
                                    oauthWindow = window.open('', `ECAL:OAUTH_SYNCWINDOW-${blob}`);
                                }

                                if (oauthWindow) {
                                    appStore.pollOauthWindow(oauthWindow);
                                } else {
                                    setTimeout(pollWindow, 200);
                                }
                            }
                            setTimeout(pollWindow, 200);
                        }}
                    > </a>
            </React.Fragment>
        </CommonStoresContext.Provider>
        </UIStatesContext.Provider>
    );
}

export default observer(WrappedRoutes);
